module.exports = __webpack_public_path__ + "static/media/lucasa.78bca4ad.jpg";